var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("notifications", { attrs: { group: "foo" } }),
      _c("Breadcrumb"),
      _vm.currentJewelSelection && !_vm.isSearching
        ? _c("div", [
            _vm.currentJewelSelection &&
            !!_vm.currentJewelSelection.name &&
            !_vm.isSearching
              ? _c("div", { staticClass: "col d-inline-flex px-0 mt-4 row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-6 text-left pl-md-0 order-2 order-md-1"
                    },
                    [
                      _c("div", { staticClass: "row d-none d-md-block" }, [
                        _c("div", { staticClass: "col-md-7" }, [
                          _c(
                            "p",
                            { staticClass: "w-100 jewel-name title-font pl-5" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentJewelSelection.name) +
                                  " "
                              )
                            ]
                          ),
                          _vm.currentJewelSelection.productType === "KIT"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "text-break w-100 jewel-description pl-5 mb-0"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("kit-contains")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c("p", {
                            staticClass:
                              "text-break w-100 jewel-description pl-5",
                            staticStyle: { "white-space": "pre-line" },
                            domProps: {
                              innerHTML: _vm._s(_vm.jewelDescription)
                            }
                          })
                        ]),
                        _vm.currentJewelSelection.productType === "KIT"
                          ? _c("div", { staticClass: "pl-5 mb-3" }, [
                              _c("div", { staticClass: "wrapper" }, [
                                _c(
                                  "table",
                                  { staticClass: "table table-image mb-0" },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "align-middle bl-color"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("model")))]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "align-middle bl-color"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("quantity")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "align-middle bl-color"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("description")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.currentJewelSelection.itemsInKit,
                                        function(item, index) {
                                          return _c("tr", { key: index }, [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-middle d-inline-flex w-100",
                                                staticStyle: {
                                                  "border-top":
                                                    "none !important"
                                                },
                                                style: {
                                                  "border-top":
                                                    index === 0
                                                      ? "none !important"
                                                      : ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "align-self": "center"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name ||
                                                            item.label
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c("img", {
                                                  staticStyle: {
                                                    "align-self": "center"
                                                  },
                                                  attrs: {
                                                    height: "50",
                                                    width: "50",
                                                    src:
                                                      _vm.baseImageUrl +
                                                      item.image,
                                                    alt: ""
                                                  }
                                                })
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-middle bl-color"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.quantity) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-middle bl-color"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.description) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-7 p-0",
                            staticStyle: { "z-index": "2" }
                          },
                          [_c("product-settings", { ref: "productSettings" })],
                          1
                        ),
                        _c("div", { staticClass: "col-md-5 margin-top-auto" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "price-info border-left-0" },
                                [
                                  _c("div", { staticClass: "w-100" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "\n                                text-left\n                                mb-0\n                                pl-md-2 pl-5\n                                text-uppercase\n                                label-menu\n                              "
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("quantity")) + " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "w-100 text-right" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.quantity,
                                            expression: "quantity"
                                          }
                                        ],
                                        staticClass:
                                          "text-center input-quantity",
                                        attrs: {
                                          type: "number",
                                          step: "1",
                                          min: "0"
                                        },
                                        domProps: { value: _vm.quantity },
                                        on: {
                                          change: _vm.changeQuantity,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.quantity = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "price-info jewel-value" },
                                [
                                  _c("div", { staticClass: "w-100" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "\n                                text-left\n                                pl-md-2 pl-5\n                                text-uppercase\n                                label-menu\n                                avg-price-label\n                              "
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("jewelValue")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _vm.isGioielleriaItalianaB2B &&
                                    _vm.retailPerc === 1 &&
                                    _vm.currentJewelSelection.productType !==
                                      "KIT" &&
                                    _vm.getPriceValue() <
                                      _vm.getAverageOrVatPrice()
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "average-price text-left pl-md-2 pl-5"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("averagePrice")) +
                                                ": "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 text-right pr-md-2 pr-5"
                                    },
                                    [
                                      _vm.basePrice
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "float-right price-value"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.getPriceValue()) +
                                                  "€ "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isGioielleriaItalianaB2B &&
                                      _vm.retailPerc === 1 &&
                                      _vm.currentJewelSelection.productType !==
                                        "KIT" &&
                                      _vm.getPriceValue() <
                                        _vm.getAverageOrVatPrice()
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "average-price float-right",
                                              staticStyle: {
                                                "text-decoration":
                                                  "line-through"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getAverageOrVatPrice()
                                                  ) +
                                                  "€ "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm.currentJewelSelection.shipmentDate
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "price-info delivery-label"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-100 pl-md-2 pl-5" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("delivery")) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-100 text-right pr-md-2 pr-5"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                (_vm.logo || _vm.writing) &&
                                                  _vm.currentJewelSelection
                                                    .engravingDate
                                                  ? _vm.currentJewelSelection
                                                      .engravingDate
                                                  : _vm.currentJewelSelection
                                                      .shipmentDate
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.note,
                                    expression: "note"
                                  }
                                ],
                                staticClass: "item-note",
                                attrs: {
                                  placeholder: _vm.$t("note.placeholder")
                                },
                                domProps: { value: _vm.note },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.note = $event.target.value
                                  }
                                }
                              })
                            ])
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn text-uppercase rounded-btn w-100",
                                  class: {
                                    "btn-secondary": _vm.addedToBasket,
                                    "btn-primary": !_vm.addedToBasket,
                                    ama: _vm.isAma
                                  },
                                  attrs: {
                                    id: "basketbtn",
                                    disabled:
                                      !_vm.jewelDescription ||
                                      _vm.addedToBasket ||
                                      !_vm.quantity ||
                                      _vm.quantity === "0"
                                  },
                                  on: { click: _vm.addToBasketProduct }
                                },
                                [
                                  _vm.addedToBasket
                                    ? _c("span", {}, [
                                        _vm._v(_vm._s(_vm.$t("addedToBasket")))
                                      ])
                                    : _c("span", {}, [
                                        _vm._v(_vm._s(_vm.$t("addToBasket")))
                                      ])
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6 order-1 order-md-2" },
                    [
                      _c("div", { staticClass: "d-md-none text-left" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "font-weight-bold w-100 jewel-name title-font"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.currentJewelSelection.name) + " "
                            )
                          ]
                        ),
                        _vm.currentJewelSelection.productType === "KIT"
                          ? _c("p", { staticClass: "text-break w-100  mb-0" }, [
                              _vm._v(" " + _vm._s(_vm.$t("kit-contains")) + " ")
                            ])
                          : _vm._e(),
                        _c("p", {
                          staticClass: "text-break w-100 jewel-description",
                          staticStyle: { "white-space": "pre-line" },
                          domProps: { innerHTML: _vm._s(_vm.jewelDescription) }
                        }),
                        _vm.currentJewelSelection.productType === "KIT"
                          ? _c("div", { staticClass: "mb-3" }, [
                              _c("div", { staticClass: "wrapper" }, [
                                _c(
                                  "table",
                                  { staticClass: "table table-image mb-0" },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "align-middle bl-color"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("model")))]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "align-middle bl-color"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("quantity")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "align-middle bl-color"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("description")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.currentJewelSelection.itemsInKit,
                                        function(item, index) {
                                          return _c("tr", { key: index }, [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-middle d-inline-flex w-100",
                                                staticStyle: {
                                                  "border-top":
                                                    "none !important"
                                                },
                                                style: {
                                                  "border-top":
                                                    index === 0
                                                      ? "none !important"
                                                      : ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "align-self": "center"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name ||
                                                            item.label
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c("img", {
                                                  staticStyle: {
                                                    "align-self": "center"
                                                  },
                                                  attrs: {
                                                    height: "50",
                                                    width: "50",
                                                    src:
                                                      _vm.baseImageUrl +
                                                      item.image,
                                                    alt: ""
                                                  }
                                                })
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-middle bl-color"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.quantity) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-middle bl-color"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.description) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm.selectedSku
                        ? _c(
                            "p",
                            { staticClass: "text-left text-muted mb-1" },
                            [
                              _vm._v(
                                " SKU " +
                                  _vm._s(
                                    _vm.selectedSku
                                      ? _vm.selectedSku +
                                          _vm.additionalSkuLabelArray.join("")
                                      : null
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.jewelDescription
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "\n              text-center\n              w-100\n              mb-3\n              position-relative\n              border-img-container\n            "
                            },
                            [
                              _vm.currentJewelSelection.productType === "KIT"
                                ? _c("img", {
                                    staticClass: "border-img-current w-100",
                                    attrs: {
                                      src:
                                        _vm.baseImageUrl +
                                        _vm.currentJewelSelection.images[0]
                                    }
                                  })
                                : _vm._e(),
                              _vm.currentJewelSelection.productType !== "KIT" &&
                              _vm.imagesAvailable &&
                              _vm.imagesAvailable.length > 0 &&
                              _vm.jewelDescription
                                ? _c("img", {
                                    staticClass: "border-img-current w-100",
                                    attrs: {
                                      src:
                                        _vm.baseImageUrl +
                                        _vm.imagesAvailable[0]
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm.imagesAvailable &&
                      _vm.imagesAvailable.length > 1 &&
                      _vm.jewelDescription
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "swiper",
                                    rawName: "v-swiper:mySwiper",
                                    value: _vm.swiperOptions,
                                    expression: "swiperOptions",
                                    arg: "mySwiper"
                                  }
                                ],
                                staticClass: "px-1 pt-2"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "swiper-wrapper" },
                                  _vm._l(_vm.imagesAvailable, function(image) {
                                    return _c(
                                      "div",
                                      {
                                        key: image,
                                        staticClass: "swiper-slide"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "border-img w-100 mb-3",
                                          attrs: {
                                            src: _vm.baseImageUrl + image
                                          }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 order-3 mt-3" },
                    [_c("related-jewels")],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm.isSearching ||
      (_vm.currentJewelSelection && !_vm.currentJewelSelection.name)
        ? _c("div", { staticClass: "col d-inline-flex px-0 mt-4 row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 mb-3 text-center justify-content-center mt-5"
              },
              [
                _c("DoubleBounce", {
                  attrs: { background: "#00274F", size: "100px" }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }